import app from '@/app';

function filter() {
	return function(val) {
		return Array.isArray(val) ? val.map(Math.abs) : Math.abs(val);
	};
}

app.filter('abs', filter);
